<template>
  <section :class="{ light: isLight }" class="body">
    <Header></Header>
    <!-- Cookie Testing Indicator -->
    <!-- <div class="text-center">
        Cookie Count Testing: 
        <button class="btn btn-secondary back-button">{{this.$store.getters.searchCountCookie === '' ? 0 : this.$store.getters.searchCountCookie.count}}</button>
    </div> -->
    <transition mode="out-in" name="pop" appear>
      <button
        v-if="isLight"
        @click="toggleDarkMode"
        class="btn btn-secondary toggle-dark"
      >
        <i class="bi bi-moon-fill"></i>
      </button>
      <button
        v-else
        @click="toggleDarkMode"
        class="btn btn-secondary toggle-dark"
      >
        <i class="bi bi-brightness-high-fill"></i>
      </button>
    </transition>
    <div class="body">
      <div class="row">
        <div class="d-none d-md-block col-3"></div>
        <transition mode="out-in" name="pop" appear>
          <div class="col-12 col-md-6">
            <LoadingSpinner
              v-if="$store.getters.isLoading & !$store.getters.dataLoaded"
            ></LoadingSpinner>
          </div>
        </transition>
        <div class="d-none d-md-block col-3"></div>
      </div>
      <div class="row">
        <div class="d-block d-lg-none col-2"></div>
        <transition mode="out-in" name="pop" appear>
          <div
            class="col-12 col-md-8 col-xl-4"
            v-if="
              !this.checkIsError.error &&
              !$store.getters.isLoading &&
              !$store.getters.dataLoaded
            "
          >
            <a
              class="p-0 btn open-ai w-100 mb-3"
              href="https://openfuture.ai/tool/savajava"
              target="_blank"
              ><img
                v-if="!this.$store.state.isLight"
                src="https://openfuture.ai/api_generate_image?product_id=649498609369b0f2c2b98e6a&amp;theme=neutral"
                alt="SavaJava"
                class="color-button neutral-button active w-100" /><img
                v-else
                src="https://openfuture.ai/api_generate_image?product_id=649498609369b0f2c2b98e6a&amp;theme=dark"
                alt="SavaJava"
                class="color-button neutral-button active w-100"
            /></a>
            <a
              class="d-lg-none"
              style="text-decoration: none"
              href="https://www.buymeacoffee.com/savajava/membership"
              target="_blank"
            >
              <button class="btn donate-btn w-100 mb-3">
                <img src="/coffee-cup.png" alt="buy me coffee" />
                <strong> Buy me a coffee </strong>
              </button>
            </a>
            <div class="form-card mb-3 p-4">
              <div class="col-12">
                <Search @submit-form="loadData"></Search>
              </div>
            </div>
            <transition mode="out-in" name="pop" appear>
              <Alert
                v-if="
                  !$store.getters.dataLoaded &&
                  !$store.getters.isLoading &&
                  $store.getters.checkIsDev
                "
                @click="loadData"
              />
            </transition>
            <div class="d-block d-lg-none col-2"></div>
          </div>
        </transition>
        <transition mode="out-in" name="pop" appear>
          <div
            class="col-12 mb-3"
            v-if="
              (!$store.getters.dataLoaded && this.checkIsError.error) ||
              ($store.getters.dataLoaded &&
                !$store.getters.isLoading &&
                this.$store.getters.loadData['counter'] != '')
            "
          >
            <dividend-output
              :data="FilteredResult"
              :error="this.checkIsError.error"
            ></dividend-output>
          </div>
        </transition>
      </div>
      <transition mode="out-in" name="pop" appear>
        <div
          class="row"
          v-if="
            !this.checkIsError.error &&
            !$store.getters.isLoading &&
            !$store.getters.dataLoaded
          "
        >
          <div class="d-block d-lg-none col-2"></div>
          <div class="col-md-8 col-xl-4">
            <div class="alert p-2" @click="openDisclaimer">
              <div class="d-flex align-items-center justify-content-start py-1">
                <p
                  class="arrow no-select mb-0 me-2"
                  :style="{
                    transform: `rotateZ(${
                      !this.$store.getters.disclaimerIsOpen ? '0deg' : '90deg'
                    })`,
                  }"
                >
                  &#9654;
                </p>
                <p class="arrow mb-0"><strong>DISCLAIMER</strong></p>
              </div>
              <div
                v-show="this.$store.getters.disclaimerIsOpen"
                class="message no-select"
              >
                <div class="d-flex align-items-center py-1">
                  <p class="mb-0">
                    All content provided herein our website is for your general
                    information only, procured from third party sources. We make
                    no warranties of any kind in relation to our content,
                    including but not limited to accuracy and updatedness. No
                    part of the content that we provide constitutes financial
                    advice, legal advice or any other form of advice meant for
                    your specific reliance for any purpose. Any use or reliance
                    on our content is solely at your own risk and discretion.
                    You should conduct your own research, review, analyse and
                    verify our content before relying on them. Stock market
                    investing is a highly risky investment that can lead to
                    major losses, please therefore consult your financial
                    advisor before making any decision. No content on our
                    website is meant to be a solicitation or offer.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="d-block d-lg-none col-2"></div>
        </div>
      </transition>
    </div>
    <div id="container-4cd63e171d86e488f3d6c02f7afd2416"></div>
    <Footer></Footer>
  </section>
</template>

<script>
import Header from "./pages/Header.vue";
import Footer from "./pages/Footer.vue";
import Alert from "./components/UI/Alert.vue";
import Search from "./components/UI/Search.vue";
import DividendOutput from "./pages/DividendOutput.vue";
import LoadingSpinner from "./components/UI/LoadingSpinner.vue";

export default {
  name: "SavaJava Global Stocks Dividend Safety Score, Reliability & Analysis Toolkit",
  components: {
    Header,
    Footer,
    Alert,
    Search,
    DividendOutput,
    LoadingSpinner,
  },
  data() {
    return {
      FilteredResult: [],
      isError: null,
      isOpen: false,
    };
  },
  mounted() {
    this.statusReport();
    this.colorSchemeWatcher();
  },
  updated() {
    this.statusReport();
  },
  computed: {
    isLight() {
      return this.$store.getters.checkIsLight;
    },
    isDev() {
      return this.$store.getters.checkIsDev;
    },
    getData() {
      return this.$store.getters.loadData;
    },
    isLoading() {
      return this.$store.getters.isLoading;
    },
    dataLoaded() {
      return this.$store.getters.dataLoaded;
    },
    checkIsError() {
      return this.$store.getters.isError;
    },
    checkDisclaimerIsOpen() {
      return this.$store.getters.disclaimerIsOpen;
    },
    searchCount() {
      return this.$store.getters.searchCount;
    },
    searchCountCookie() {
      return this.$store.getters.searchCountCookie;
    },
  },
  methods: {
    colorSchemeWatcher() {
      let body = document.querySelector("body");
      if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
        body.classList.remove("light");
        return this.$store.dispatch("toggleLightMode", false);
      }
      body.classList.add("light");
      return this.$store.dispatch("toggleLightMode", true);
    },
    statusReport() {
      this.isError = this.checkIsError;
      console.log(this.isError);
    },
    toggleDarkMode() {
      let body = document.querySelector("body");
      this.$store.dispatch("toggleLightMode");
      body.classList.toggle("light");
    },
    loadData() {
      if (this.$store.getters.loadData.status !== 404) {
        if (this.$store.getters.loadData[0]["Stock Type"] === "Non-Dividend") {
          return (this.FilteredResult = this.$store.getters.loadData[0]);
        }
        if (this.$store.getters.loadData["Stock Type"] === "Dividend") {
          return (this.FilteredResult = this.$store.getters.loadData);
        }
      } else {
        return (this.FilteredResult = this.$store.getters.loadData);
      }
    },
    openDisclaimer() {
      this.$store.dispatch("openDisclaimer");
      console.log(this.checkDisclaimerIsOpen);
    },
  },
};
</script>

<style>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import url("https://cdn.jsdelivr.net/npm/bootstrap-icons@1.8.3/font/bootstrap-icons.css");

#container-4cd63e171d86e488f3d6c02f7afd2416
  .container-4cd63e171d86e488f3d6c02f7afd2416__bn-container {
  flex: 1 1 25%;
  padding: 20px;
}

::selection {
  color: #333;
  background: #aaa;
}

/* body.fixed {
  position: fixed;
  overflow: hidden;
} */

.btn.open-ai:hover,
.btn.open-ai:focus-visible,
.btn.open-ai:focus,
.btn.open-ai:focus-within,
.btn.open-ai:active {
  box-shadow: none;
  outline: transparent;
}

.toggle-dark {
  position: absolute;
  top: 24px;
  right: 15px;
  transition: all 0.3s ease;
  border-radius: 50px;
  height: 34px;
  width: 36px;
  padding: 0px;
}

.form-control:focus,
.btn.btn-secondary:focus {
  box-shadow: 0 2px 4px 0 rgb(255 255 255 / 15%);
  border: 1px solid #aaa;
}

p.logo {
  font-size: 55px;
  white-space: nowrap;
}

h1.tagline {
  color: #ccc;
  font-size: 15px;
}

h2 {
  font-size: 30px;
}

h3 {
  font-size: 25px;
}

.form-card {
  background: #222;
  border-radius: 5px;
  color: #ccc;
  z-index: 1;
  box-shadow: 0px 2px 10px 0px rgb(255 255 255 / 75%);
  border-radius: 4px;
  background-blend-mode: multiply;
}

.alert {
  z-index: 1;
}

span.output {
  color: #827ce0;
  font-weight: bold;
}

.light span.output {
  color: #4d498c;
}

.btn {
  transition: all 0.1s ease-in-out;
}

.btn:active {
  transform: scale(0.95);
}

section.body,
body {
  transition: all 0.3s ease-in-out;
  background: #333;
  color: #ccc;
  min-height: 800px;
}

p a {
  color: #333;
  font-weight: bold;
}

p.arrow,
.message {
  color: #333;
  font-size: 15px;
  cursor: pointer;
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
    "Courier New", monospace;
}

.message {
  font-size: 13px;
}

div.alert {
  background: #aaa;
  border-radius: 5px;
}

.donate-btn {
  background-color: #ffdd00;
  border: 1px solid #ffc439;
  animation: glower 1.5s linear infinite;
  padding: 3px;
}

.donate-btn img {
  height: 30px;
}

.btn-secondary {
  transition: all 0.3s ease-in-out;
  background-color: #eee;
  background-blend-mode: multiply;
  color: #333;
  border: 1px solid #aaa;
}

.btn-secondary:hover,
.btn-secondary:focus {
  background: #ccc;
  color: #333;
  border: 1px solid #aaa;
}

i.bi::before {
  transition: all 0.3s ease-in-out;
}

.btn-secondary:hover .bi::before {
  transform: scale(1.25);
}

.btn-secondary:hover .bi.bi-moon-fill::before,
.btn-secondary:hover .bi.bi-brightness-high-fill::before {
  transform: scale(1.25) rotateZ(360deg);
}

div.body {
  padding: 20px;
  height: 100%;
}

.padded {
  padding: 5px 15px 5px 24px;
  margin: 0 0 0 15px;
}

.no-select {
  user-select: none;
}

/*Light Mode*/
.light ::selection {
  color: #aaa;
  background: #333;
}

.light h1.tagline {
  color: #333;
}

.light .form-control:focus,
.light .btn.btn-secondary:focus {
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%);
  border: 1px solid #999;
}

.light .form-card {
  background-color: #ddd;
  background-blend-mode: unset;
  color: #333;
  border: 1px solid #aaa;
  box-shadow: 0px 2px 10px 0px rgb(0 0 0 / 20%);
  border-radius: 4px;
}

section.light,
body.light {
  background: #ccc;
  color: #333;
  height: 100%;
}

.light p {
  color: #333;
}
.light p.arrow,
.light .message p,
.light .message a {
  color: #aaa;
}
.light div.alert {
  background: #333;
}

.light .btn-secondary {
  background-color: #333;
  color: #ccc;
}

.light .btn-secondary:hover {
  background: #292929;
  color: #ccc;
}

.light .donate-btn {
  animation: glower-light 1.5s linear infinite;
}

@keyframes glower {
  0%,
  100% {
    box-shadow: 0 0 0 0.15rem rgba(145, 143, 130, 0.5);
  }

  40%,
  60% {
    box-shadow: 0 0 0 0.4rem rgba(145, 143, 130, 0.5);
  }
}

@keyframes glower-light {
  0%,
  100% {
    box-shadow: 0 0 0 0.15rem rgba(204, 179, 14, 0.5);
  }

  40%,
  60% {
    box-shadow: 0 0 0 0.4rem rgba(204, 179, 14, 0.5);
  }
}

/*Vue Animation*/
.pop-enter-from,
.pop-leave-to {
  opacity: 0;
  transform: scale(0);
}

.pop-enter-active {
  transition: all 0.2s ease-out;
}
.pop-leave-active {
  transition: all 0.2s ease-in;
}
.pop-enter-to,
.pop-leave-from {
  opacity: 1;
  transform: scale(1);
}

.button-enter-from {
  opacity: 0;
  transform: rotateX(-180deg);
}
.button-leave-to {
  opacity: 0;
  transform: rotateX(180deg);
}
.button-enter-active {
  transition: all 0.2s ease-out;
}
.button-leave-active {
  transition: all 0.2s ease-in;
}
.button-enter-to,
.button-leave-from {
  opacity: 1;
  transform: rotateX(0);
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateX(-50px);
}
.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(50px);
}
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.3s ease-in;
}
.slide-fade-enter-to,
.slide-fade-leave-from {
  opacity: 1;
  transform: translateX(0);
}

.alert-enter-from {
  opacity: 1;
  transform: translateY(-10px);
}

select:active,
input:active,
select:focus,
input:focus,
select:focus,
input:active {
  box-shadow: 0px 0px 10px 0px rgb(255 255 255 / 40%) !important;
}

.light select:active,
.light input:active,
.light select:focus,
.light input:focus,
.light select:focus,
.light input:active {
  box-shadow: 0px 0px 10px 0px rgb(0 0 0 / 20%) !important;
}

@media only screen and (max-width: 992px) {
  .padded {
    padding: 5px 20px 5px 20px !important;
  }
}
@media only screen and (min-width: 992px) {
  body {
    overflow: auto;
  }

  h1 {
    font-size: 60px;
  }

  h2 {
    font-size: 35px;
  }

  h3 {
    font-size: 30px;
  }
}
</style>
